<!-- Spinner -->

<!-- Content -->
@if (question && trainingResult && trainingResult.answer !== undefined) {
  <!-- Header -->
  <medsurf-quiz-question-header [index]="((trainingSharedFacade.quizActive$ | async) ? undefined : question.customEnumeration) || (((trainingSharedFacade.selectedQuestionIndex$(question.id) | async) || index) + 1).toString()"
    [checkedAndCorrect]="trainingResult.showFeedback && isCorrect()"
    [questionType]="question.type">
  </medsurf-quiz-question-header>
  <!-- Question Form -->
  <form name="form"
    class="mdsf-quiz-form"
    #container>
    <!-- Question Text -->
    <medsurf-text [text]="question.content"></medsurf-text>
    <!-- Free Text -->
    <div class="freetext-grid">
      <div class="input-group">
        @if ((menuSharedFacade.showPrintForAuthor$ | async) === false) {
          <textarea #textarea
            rows="3"
            name="freeTextQuestion{{question.order}}"
            class="form-control textarea-answers"
            [(ngModel)]="trainingResult.text"
            [ngModelOptions]="{ updateOn: 'blur' }"
            (ngModelChange)="onChange()"
            (input)="resizeTextarea()"
            [readOnly]="trainingResult.showFeedback">
          </textarea>
        }
        @if ((menuSharedFacade.showPrintForAuthor$ | async)) {
          <textarea #textarea
            rows="3"
            name="freeTextQuestion{{question.order}}"
            class="form-control textarea-answers"
            [value]="question.solutionText | stripTags"
            (change)="onChange()"
            (input)="resizeTextarea()"
            [readOnly]="trainingResult.showFeedback">
          </textarea>
        }
      </div>
      @if (trainingResult.showFeedback) {
        <div class="answer-group">
          <!-- Solution Text -->
          @if (question.solutionText && trainingResult.showFeedback) {
            <div class="">
              <strong>{{ 'Solution' | translate }}</strong>
              <medsurf-text [text]="question.solutionText"></medsurf-text>
            </div>
          }
          <!-- Explanation -->
          @if (question.explanation && trainingResult.showExplanation) {
            <div>
              <strong>{{ 'explanation' | translate }}</strong>
              <medsurf-text [text]="question.explanation"></medsurf-text>
            </div>
          }
          <!-- Self Evaluation -->
          @if (trainingResult.showFeedback) {
            <strong>{{ 'self_declaration' | translate }}</strong>
            <p>{{ 'self_declaration_text' | translate}}</p>
            <div class="d-flex">
              <button type="button"
                class="mdsf-btn mdsf-btn-correct d-flex mr-2"
                role="button"
                (click)="evaluateQuestion(true)"
                [class.mdsf-btn-correct-selected]="this.trainingResult.answer === true">
                <i class="fa fa-fw fa-check"></i> {{ 'correct' | translate }}
              </button>
              <button type="button"
                class="mdsf-btn mdsf-btn-error d-flex"
                role="button"
                (click)="evaluateQuestion(false)"
                [class.mdsf-btn-error-selected]="this.trainingResult.answer === false">
                <i class="fa fa-fw fa-times"></i> {{ 'wrong' | translate }}
              </button>
            </div>
          }
        </div>
      }
      @if ((menuSharedFacade.showPrint$ | async) === false && question.solutionText !== null) {
        <medsurf-quiz-question-footer #footer
          class="mt-2"
          [question]="question"
          [trainingResult]="trainingResult"
          [isCorrect]="isCorrect"
          [passRequired]="passRequired"
          [(showRequired)]="showRequired"
          [ngStyle]="{'order': 100}">
        </medsurf-quiz-question-footer>
      }
    </div>
    <!-- Print Explanation -->
    @if (question.explanation && (menuSharedFacade.showPrintForAuthor$ | async)) {
      <div class="mt-3">
        <strong>{{ 'explanation' | translate }}</strong>
        <medsurf-text [text]="question.explanation"></medsurf-text>
      </div>
    }
  </form>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
